(function(){"use strict";const SALE_TEXT="Early Black Friday Sale",TOP_BAR_TEXT="Early Black Friday Sale",LONG_FORM_SALE_TEXT="Early Black Friday Sale - 70% OFF",currentPath=window.location.pathname.toLowerCase().replace(/\/+$/,""),hideTimer=["/esm-tfbm-coc-adv","/esm-tfbm-coc-sp","/sciaticalm-coc-sp","/esm-rltb-coc-sp1","/esm-rltb-coc-sp1-80off","/backpatch-refill","/hrn-coc-adv-esm","/hrn-coc-asp-esm","/tfbm-coc-adv-sc-2.0-esm","/tfbm-coc-sp-sc-2.0-esm","/tfbm-coc-ck-sc-2.0-esm","/backpatch-refill-qr"].includes(currentPath),is80OffPage=currentPath==="/esm-rltb-coc-sp1-80off",SALES_BANNER_TITLE="BLACK FRIDAY EARLY ACCESS",SALES_BANNER_SUBTITLE=is80OffPage?"Up To 80% Off With FREE GIFTS":"Up To 70% Off With FREE GIFTS";function injectStyles(){const oldStyles=document.getElementById("ss-global-sale-styles");oldStyles&&oldStyles.remove();const styles=`

      .ss-sale-timer-banner,

      .ss-sale-timer-banner * {

        box-sizing: border-box;

      }



      .ss-sale-timer-banner {

        width: 100% !important;

        min-height: 58px !important;

        margin: 0 !important;

        padding: 0 !important;



        background: linear-gradient(

          90deg,

          #0D0D0D 0%,

          #1B1B1B 55%,

          #303030 100%

        ) !important;



        font-family: "Open Sans", Arial, sans-serif !important;

        color: #ffffff !important;

      }



      .ss-sale-timer-inner {

        width: 100% !important;

        max-width: 760px !important;

        min-height: 58px !important;

        margin: 0 auto !important;

        padding: 5px 16px !important;

        display: flex !important;

        align-items: center !important;

        justify-content: center !important;

        gap: 30px !important;

      }



      .ss-sale-timer-copy {

        display: flex !important;

        flex-direction: column !important;

        align-items: flex-start !important;

        justify-content: center !important;

        margin: 0 !important;

        padding: 0 !important;

      }



      .ss-sale-timer-title {

        margin: 0 !important;

        padding: 0 !important;

        font-family: "Open Sans", Arial, sans-serif !important;

        font-size: 16px !important;

        font-weight: 800 !important;

        line-height: 1.15 !important;

        letter-spacing: 0.3px !important;

        text-transform: uppercase !important;

        color: #ffffff !important;

        white-space: nowrap !important;

      }



      .ss-sale-timer-subtitle {

        margin: 3px 0 0 !important;

        padding: 0 !important;

        font-family: "Open Sans", Arial, sans-serif !important;

        font-size: 11px !important;

        font-weight: 500 !important;

        line-height: 1.2 !important;

        letter-spacing: 0 !important;

        color: #ffffff !important;

        white-space: nowrap !important;

      }



      .ss-sale-countdown {

        display: flex !important;

        align-items: flex-start !important;

        justify-content: center !important;

        gap: 9px !important;

        margin: 0 !important;

        padding: 0 !important;

      }



      .ss-sale-countdown-unit {

        min-width: 34px !important;

        display: flex !important;

        flex-direction: column !important;

        align-items: center !important;

        justify-content: center !important;

      }



      .ss-sale-countdown-number {

        margin: 0 !important;

        padding: 0 !important;

        font-family: "Open Sans", Arial, sans-serif !important;

        font-size: 17px !important;

        font-weight: 800 !important;

        line-height: 1 !important;

        color: #ffffff !important;

      }



      .ss-sale-countdown-label {

        margin-top: 4px !important;

        font-family: "Open Sans", Arial, sans-serif !important;

        font-size: 7px !important;

        font-weight: 500 !important;

        line-height: 1 !important;

        text-transform: uppercase !important;

        color: rgba(255, 255, 255, 0.85) !important;

      }



      .ss-sale-countdown-separator {

        margin-top: -1px !important;

        font-family: "Open Sans", Arial, sans-serif !important;

        font-size: 17px !important;

        font-weight: 800 !important;

        line-height: 1 !important;

        color: #ffffff !important;

      }



      .ss-sale-timer-banner.ss-no-timer-banner

      .ss-sale-timer-inner {

        gap: 0 !important;

      }



      .ss-sale-timer-banner.ss-no-timer-banner

      .ss-sale-timer-copy {

        align-items: center !important;

        text-align: center !important;

      }



      .sale-text-global {

        display: inline-block;

        padding: 0 8px;

      }



      .sale-text-global-no-space {

        display: inline-block;

      }



      .top-bar-global-text {

        text-transform: uppercase;

        color: white;

        font-size: 22px;

      }



      #isf1rf {

        text-align: left !important;

      }



      @media screen and (min-width: 768px) {

        .desktop-none {

          display: none !important;

        }



        .mobile-none {

          display: block !important;

        }

      }



      @media screen and (max-width: 767px) {

        .mobile-none {

          display: none !important;

        }



        .desktop-none {

          display: block !important;

        }



        .ss-sale-timer-banner {

          min-height: 73px !important;

        }



        .ss-sale-timer-inner {

          min-height: 73px !important;

          padding: 7px 8px !important;

          flex-direction: column !important;

          gap: 6px !important;

        }



        .ss-sale-timer-copy {

          width: 100% !important;

          align-items: center !important;

          text-align: center !important;

        }



        .ss-sale-timer-title {

          font-size: 12px !important;

          line-height: 1.15 !important;

          letter-spacing: 0 !important;

          white-space: nowrap !important;

        }



        .ss-sale-timer-subtitle {

          margin-top: 3px !important;

          font-size: 10px !important;

          line-height: 1.15 !important;

          white-space: normal !important;

          text-align: center !important;

        }



        .ss-sale-countdown {

          gap: 7px !important;

        }



        .ss-sale-countdown-unit {

          min-width: 30px !important;

        }



        .ss-sale-countdown-number {

          font-size: 14px !important;

        }



        .ss-sale-countdown-label {

          margin-top: 3px !important;

          font-size: 6px !important;

        }



        .ss-sale-countdown-separator {

          font-size: 14px !important;

        }



        .ss-sale-timer-banner.ss-no-timer-banner {

          min-height: 58px !important;

        }



        .ss-sale-timer-banner.ss-no-timer-banner

        .ss-sale-timer-inner {

          min-height: 58px !important;

          padding: 5px 8px !important;

          gap: 0 !important;

          flex-direction: column !important;

        }

      }

    `,styleSheet=document.createElement("style");styleSheet.id="ss-global-sale-styles",styleSheet.type="text/css",styleSheet.textContent=styles,document.head.appendChild(styleSheet)}const bannerHTML=`

    <div class="ss-sale-timer-banner ${hideTimer?"ss-no-timer-banner":""}">

      <div class="ss-sale-timer-inner">

        <div class="ss-sale-timer-copy">

          <div class="ss-sale-timer-title">

            ${SALES_BANNER_TITLE}

          </div>



          <div class="ss-sale-timer-subtitle">

            ${SALES_BANNER_SUBTITLE}

          </div>

        </div>



        ${hideTimer?"":`

      <div class="ss-sale-countdown">

        <div class="ss-sale-countdown-unit">

          <span class="ss-sale-countdown-number" id="ss-sale-days">00</span>

          <span class="ss-sale-countdown-label">DAYS</span>

        </div>



        <span class="ss-sale-countdown-separator">:</span>



        <div class="ss-sale-countdown-unit">

          <span class="ss-sale-countdown-number" id="ss-sale-hours">00</span>

          <span class="ss-sale-countdown-label">HRS</span>

        </div>



        <span class="ss-sale-countdown-separator">:</span>



        <div class="ss-sale-countdown-unit">

          <span class="ss-sale-countdown-number" id="ss-sale-minutes">00</span>

          <span class="ss-sale-countdown-label">MINS</span>

        </div>



        <span class="ss-sale-countdown-separator">:</span>



        <div class="ss-sale-countdown-unit">

          <span class="ss-sale-countdown-number" id="ss-sale-seconds">00</span>

          <span class="ss-sale-countdown-label">SECS</span>

        </div>

      </div>

    `}

      </div>

    </div>

  `;function padNumber(number){return String(number).padStart(2,"0")}function updateSaleCountdown(){if(hideTimer)return;const daysElement=document.getElementById("ss-sale-days"),hoursElement=document.getElementById("ss-sale-hours"),minutesElement=document.getElementById("ss-sale-minutes"),secondsElement=document.getElementById("ss-sale-seconds");if(!daysElement||!hoursElement||!minutesElement||!secondsElement)return;const nowMs=Date.now(),offsetMs=7*60*60*1000,dayMs=86400000,nextMidnight=(Math.floor((nowMs-offsetMs)/dayMs)+1)*dayMs+offsetMs;document.querySelectorAll(".today-date").forEach(el=>{el.textContent=new Date(nowMs-offsetMs).toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric",timeZone:"UTC"})});const difference=Math.ceil(Math.max(0,nextMidnight-nowMs)/1000)*1000,days=0,hours=Math.floor(difference/(1e3*60*60)),minutes=Math.floor(difference/(1e3*60)%60),seconds=Math.floor(difference/1e3%60);daysElement.textContent=padNumber(days),hoursElement.textContent=padNumber(hours),minutesElement.textContent=padNumber(minutes),secondsElement.textContent=padNumber(seconds)}function updateGlobalContent(){const bannerContainer=document.getElementById("global-banner");bannerContainer&&(bannerContainer.innerHTML=bannerHTML),document.querySelectorAll(".sale-text-global, .sale-text-global-no-space").forEach(function(element){element.textContent=SALE_TEXT}),document.querySelectorAll(".top-bar-global-text").forEach(function(element){element.textContent=TOP_BAR_TEXT}),document.querySelectorAll(".long-form-sale-global").forEach(function(element){element.textContent=LONG_FORM_SALE_TEXT})}function initGlobalBanner(){injectStyles(),updateGlobalContent(),hideTimer||(updateSaleCountdown(),setInterval(updateSaleCountdown,1e3))}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",initGlobalBanner):initGlobalBanner()})();

//# sourceMappingURL=/s/files/1/0252/1261/6781/files/banner_2_1.js.map?v=1792086247

